import * as React from 'react';

import { IconProps } from './Icon';

export const TruckIcon = ({ width, height, className, color }: IconProps) => (
  <svg
    className={className}
    color={color || '#59636E'}
    height={height}
    id="Capa_1"
    version="1.1"
    viewBox="0 0 512 512"
    width={width}
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    y="0px"
  >
    <path d="m504 141.789-173.82-100.355a15.994 15.994 0 0 0 -8-2.144h-98.438a16 16 0 1 0 0 32h38.725l-118.395 68.355h-128.072a16 16 0 0 0 0 32h128.072l162.107 93.593v163.762l-149.82-86.5a16.007 16.007 0 0 0 -8-2.144h-132.359a16 16 0 0 0 0 32h128.072l170.108 98.21a16 16 0 0 0 16 0l173.82-100.354a16 16 0 0 0 8-13.857v-200.71a16 16 0 0 0 -8-13.856zm-40 13.856-141.82 81.88-141.82-81.88 141.82-81.88zm-125.821 273.355v-163.762l141.821-81.881v163.761zm-292.095-373.71a16 16 0 0 1 16-16h103.492a16 16 0 0 1 0 32h-103.492a16 16 0 0 1 -16-16zm16 216.71a16 16 0 1 1 0-32h83.206a16 16 0 0 1 0 32z" />
  </svg>
);
